import ToolStylus from './ToolStylus';

class ToolStylusAssistant extends ToolStylus {
  static toolName = 'AI assistant';

  static action({ controller }) {
    if (window.featureFlags?.awt_390_whiteboard_ai_assistant) {
      controller.actionOpenSidePanel('assistant');
    } else {
      controller.actionToggleAIAssistant();
    }
  }
}

export default ToolStylusAssistant;
